import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import { StepHeaderSkeleton, SummaryTableSkeleton } from './stepSkeletonParts';

/** Krok W1 — podsumowanie zmian. */
const ChangePackageSummaryStepSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <Card
    highlighted
    className={cn('@container overflow-hidden', className)}
    {...props}
  >
    <StepHeaderSkeleton />
    <SummaryTableSkeleton />

    <div className="@min-[700px]:px-7 flex items-center gap-3.5 bg-neutral-50 px-4 py-4">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="ml-auto h-7 w-40" />
    </div>

    <div className="@max-[940px]:flex-col @max-[940px]:items-stretch @min-[700px]:px-7 flex items-center gap-3.5 px-4 pb-[22px] pt-[18px]">
      <Skeleton className="h-4 w-96 max-w-full" />
      <div className="@max-[940px]:ml-0 @max-[940px]:flex-col ml-auto flex shrink-0 gap-2.5">
        <Skeleton className="@max-[940px]:w-full h-11 w-40 rounded-[9px]" />
        <Skeleton className="@max-[940px]:w-full h-11 w-48 rounded-[9px]" />
      </div>
    </div>
  </Card>
);

export default ChangePackageSummaryStepSkeleton;
